export default [
  {
    name: 'sales_invoices',
    key: 'sales_invoices.list.title',
    icon: 'fa-file-invoice',
    title: 'Tarjoukset',
    graph: {
      type: 'chart.js',
      chartType: 'bar',
      chartData: {
        datasets: [{
          label: 'My First dataset',
          data: [...Array(30)].map((item, i) => {
            let number = Math.floor(Math.random() * (100))
            if ([3, 4, 5, 8, 12, 17, 20].includes(i)) { number = number * -1 }
            else {
              number = Math.floor(number * 3)
            }
            return number
          }),
          backgroundColor: [...Array(30)].map((item, i) => {
            return [3, 4, 5, 8, 12, 17, 20].includes(i) ? '#FBC02D' : '#B0BEC5'
          }),
        }],
        labels: [...Array(30)].map(i => ''),
      },
      chartOptions: {
        responsive: true,
        legend: {
          display: false,
          position: 'top',
        },
        title: {
          display: false,
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              const value = tooltipItem.yLabel
              return value < 0 ? -value : value
            }
          }
        },
        scales: {
          x: {
            ticks: {
              display: false
            },
            grid: {
              display: false
            }
          },
          y: {
            grid: {
              display: false
            },
            ticks: {
              display: false,
              beginAtZero: true,
            }
          },
        }
      },
    },
    levels: 7,
    level: 2,
    points: 265,
    color: 'green',
    enabled: false,
  },
  {
    name: 'products',
    key: 'products.list.title',
    icon: '',
    title: 'Myynti',
    graph: {
      type: 'number',
      value: '258,53',
      direction: 'up',
    },
    levels: 5,
    level: 3,
    points: 326,
    color: 'green',
    enabled: true,
  },
  {
    name: 'costs',
    key: 'costs.list.title',
    icon: 'fa-euro-sign',
    title: 'Osto',
    graph: {
      type: 'multi-gauge',
    },
    levels: 7,
    level: 5,
    points: 494,
    color: 'green',
    enabled: false,
  },
  {
    name: 'work_events',
    key: 'work_events.list.title',
    icon: 'fa-calendar-check',
    title: 'Tuotanto',
    graph: {
      type: 'custom-bars',
    },
    levels: 7,
    level: 5,
    points: 494,
    color: 'green',
    enabled: true,
  },
  {
    name: 'works',
    key: 'works.list.title',
    icon: 'fa-tools',
    title: 'Logistiikka',
    graph: {
      type: '2-weeks',
    },
    levels: 6,
    level: 1,
    points: 494,
    color: 'green',
    enabled: true,
  },
  {
    name: 'orders',
    key: 'sales_orders.list.title',
    icon: 'fa-file-import',
    title: 'Varasto',
    graph: {
      type: 'number',
      value: '124.74',
      direction: 'down',
    },
    levels: 7,
    level: 5,
    points: 494,
    color: 'blue',
    enabled: true,
  },
  {
    name: 'offers',
    key: 'sales_offers.list.title',
    icon: 'fa-file-invoice-dollar',
    title: 'Laatu',
    graph: {
      type: 'chart.js',
      chartType: 'bar',
      chartData: {
        datasets:
          [{
            data: [16, 35, 17, 82, 32, 66],
            backgroundColor: ['#E0E0E0', '#E0E0E0', '#E0E0E0', '#E0E0E0', '#E0E0E0', '#E0E0E0'],
          },
          ],
        labels: ['', '', '', '', '', '']
      },
      chartOptions: {
        title: { text: '', display: false },
        legend: { display: false },
        scales: {
          x: {
            ticks: {
              display: false
            },
            grid: {
              display: false
            }
          },
          y: {
            grid: {
              display: false
            },
            ticks: {
              display: false,
              beginAtZero: true,
            }
          },
          y2: [{ ticks: { beginAtZero: true } }],
        },
      },
    },
    levels: 5,
    level: 4,
    points: 494,
    color: 'green',
    enabled: true,
  },
  {
    name: 'people',
    key: 'people.list.title',
    icon: 'fa-user',
    title: 'Henkilöstö',
    graph: {
      type: 'people',
    },
    levels: 5,
    level: 4,
    points: 494,
    color: 'orange',
    enabled: true,
  },
  {
    name: 'projects',
    key: 'projects.list.title',
    icon: 'fa-folder-open',
    title: 'Hallinto',
    graph: {
      type: 'chart.js',
      chartType: 'line',
      chartData: {
        datasets:
          [{
            data: [16, 35, -17, 35, 22, 82, 32, 66, 23, 17, 35, 42],
            backgroundColor: 'white',
          }],
        labels: ['', '', '', '', '', '', '', '', '', '', '', '']
      },
      chartOptions: {
        title: { text: '', display: false },
        legend: { display: false },
        scales: {
          x: {
            ticks: {
              display: false
            },
            grid: {
              display: false
            }
          },
          y: {
            grid: {
              display: false
            },
            ticks: {
              display: false,
              beginAtZero: true,
            }
          },
        },
      },
    },
    levels: 7,
    level: 5,
    points: 494,
    color: 'green',
    enabled: true,
  },
]
